import React from "react";
import { Pagination } from "react-bootstrap";
import { getPaginationItems } from "../../features/utils/paginationUtils";

const PaginationComponent = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const pages = getPaginationItems(currentPage, totalPages);

  return (
    <Pagination className="justify-content-end flex-wrap">
      <Pagination.Prev
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />

      {pages.map((page, index) =>
        page === "..." ? (
          <Pagination.Ellipsis key={index} disabled />
        ) : (
          <Pagination.Item
            key={index}
            active={page === currentPage}
            onClick={() => onPageChange(page)}
          >
            {page}
          </Pagination.Item>
        )
      )}

      <Pagination.Next
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    </Pagination>
  );
};

export default PaginationComponent;